import { ApiRequest } from '../api/request';

export class AccountIdValidationService extends ApiRequest {
  constructor($http, $q) {
    'ngInject';
    super({ $http, $q });
  }

  static isValidEbaseAccountId(value) {
    return /^99\d{9}$/.test(value);
  }

  static isValidAccountId(value) {
    return /\d{11}$/.test(value);
  }

  static isJustNumber(value) {
    return /^\d+$/.test(value);
  }

  static fullfillsPattern(value, pattern, revert = false) {
    // support multiple pattern
    if (angular.isArray(pattern)) {
      return pattern.every((p) =>
        AccountIdValidationService.fullfillsPattern(value, p, revert),
      );
    }

    const match = new RegExp(pattern, 'ig').test(value);
    return revert ? !match : match;
  }

  static fullfillsRanges(value, ranges) {
    const num = +value;
    return ranges.some((range) => {
      const { from, to } = range;
      return num >= from && num <= to;
    });
  }

  checkAccountId(depotNumber) {
    return this.$http({
      method: 'POST',
      url: '/api/validation/depotnumber ',
      data: {
        depotNumber,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/domain/accountIdValidation.service.js